export default "__VITE_ASSET__BqD8P5ef__"